/** Angular */
import { Injectable } from '@angular/core';

/** Rxjs */
import { Observable } from 'rxjs';

/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

/** Sixense */
import { BydModel } from '@sixense/byd-core-service';

/** Model */
import { BydBimModels } from '../models/byd-bim-models';

/** Interface */
import { BydBimModelsInterface } from '../interfaces/byd-bim-models.interface';

@Injectable({
  providedIn: 'root',
})
export class BydBimModelsService extends BydRhsAbstractService {
  /**
   *
   */
  public path: string;

  /**
   * Get all bim models.
   *
   * @param projectId id of the project
   * @returns Observable<DsBimModels>
   */
  public getBimModels(projectId: number): Observable<BydModel<BydBimModels>> {
    this.path = `/v1/dsmaps/projects/${projectId}/plans/models/`;
    return this.getModels<BydBimModels>();
  }

  /**
   * Create DsBimModels instance.
   *
   * @param jsonObject the flat json object
   * @returns an 'DsBimModels' instance
   */
  public createNewInstance(jsonObject: BydBimModelsInterface): BydBimModels {
    return new BydBimModels(jsonObject);
  }
}
